const DEFAULT_FONT_FACE = '"Source Sans Pro"';
const DEFAULT_FONT_FAMILY = `${DEFAULT_FONT_FACE},
-apple-system,
system-ui,
BlinkMacSystemFont,
"Segoe UI",
Roboto,
"Helvetica Neue",
Arial,
sans-serif`;
export function getFont(args) {
  const {
    fontFace = DEFAULT_FONT_FACE,
    fontFamily = DEFAULT_FONT_FAMILY
  } = args !== null && args !== void 0 ? args : {};
  return {
    FACE: fontFace,
    FAMILY: fontFamily,
    // keep this for backwards compatibility
    BASE_SIZE: '16px',
    CAPITAL_LETTER_SCALE: 0.71,
    DESCENDER_HEIGHT_SCALE: 0.15,
    WEIGHT: {
      REGULAR: 400,
      SEMI_BOLD: 600
    }
  };
}